import type { InspectionErrand } from '@pigello/pigello-matrix';

export function getInspectionErrandConnectedObject(
  inspection: InspectionErrand
) {
  if (inspection.apartment) {
    return inspection.apartment;
  }

  if (inspection.industrialPremises) {
    return inspection.industrialPremises;
  }

  if (inspection.parkingSpot) {
    return inspection.parkingSpot;
  }

  if (inspection.commonArea) {
    return inspection.commonArea;
  }

  if (inspection.brfApartment) {
    return inspection.brfApartment;
  }

  if (inspection.outdoorSection) {
    return inspection.outdoorSection;
  }

  return null;
}

export function getInspectionErrandConnectedObjectModelName(
  inspection: InspectionErrand
) {
  if (inspection.apartment) {
    return 'apartment';
  }

  if (inspection.industrialPremises) {
    return 'industrialpremises';
  }

  if (inspection.parkingSpot) {
    return 'parkingspot';
  }

  if (inspection.commonArea) {
    return 'commonarea';
  }

  if (inspection.brfApartment) {
    return 'brfapartment';
  }

  if (inspection.outdoorSection) {
    return 'outdoorsection';
  }

  return null;
}
